// extracted by mini-css-extract-plugin
export default {"wrapper":"order-declination_wrapper__xnYDr","opacity-transition":"order-declination_opacity-transition__AVu8-"};